import React from "react";
import { Fade } from "react-awesome-reveal";

export default function About() {
  return (
    <div className="about-page">
      <div className="container-fluid main">
        <div className="row">
          <div className="col-sm-4">
            <h1 className="head">
              Bridging Enterprise Logic with Impactful Design.
            </h1>
            <br />
            <br />
            <h5>Email :</h5>
            <a className="iconf" href="mailto:ianshulgora+web@gmail.com">
              ianshulgora@gmail.com
            </a>
            <br />
            <br />
            <h5>Say Hello :</h5>
            <a href="https://instagram.com/ianshulgora" target="blank">
              <i className="fab iconf fa-instagram fa-2x"></i>
            </a>
            &nbsp; &nbsp;
            <a href="https://www.linkedin.com/in/anshul-gora" target="blank">
              <i className="fab iconf fa-linkedin-in fa-2x"></i>
            </a>
            &nbsp; &nbsp;
            <a href="https://twitter.com/ianshulgora" target="blank">
              <i className="fab iconf fa-x-twitter fa-2x"></i>
            </a>
            &nbsp; &nbsp;
            <a href="https://github.com/anshulgora" target="blank">
              <i className="fab iconf fa-github fa-2x"></i>
            </a>
            &nbsp; &nbsp;
            <br />
            <br />
            <br />
            <br />
          </div>
          <div className="col-sm-8  me">
            <h5 className="text-muted">
              I am a ServiceNow Developer and Frontend Engineer specializing in
              building scalable, enterprise-grade digital solutions. With a
              B.Tech in Computer Science and professional experience at Tata
              Consultancy Services (TCS), I focus on transforming complex
              business requirements into high-performance applications. My
              technical expertise lies in the intersection of ITSM automation
              and Modern Web Development, ensuring that every system I build is
              both technically robust and user-efficient.
              <br />
              <br />
              Currently, I am deeply involved in SPM implementation and
              CAD-driven custom application development. I have a strong command
              over JavaScript, ReactJS, and ServiceNow APIs, with a proven track
              record of architecting CSDM-compliant solutions that reduce manual
              intervention. As a CSA and CAD certified professional, I am
              committed to following industry best practices to deliver clean,
              maintainable code that drives enterprise visibility and
              organizational growth.
            </h5>
            <br />

            <div>
              <ul className="text-muted">
                <li>
                  <strong>B.Tech in Computer Science</strong> (2024 Graduate)
                </li>
                <li>
                  <strong>Focus:</strong> ServiceNow (ITSM/SPM), ReactJS, and
                  UI/UX Design
                </li>
                {/* <li>
                  <strong>Certifications:</strong> Certified Application
                  Developer (CAD) & System Administrator (CSA)
                </li> */}
                <li>
                  <strong>Current Role:</strong> ServiceNow Developer at Tata
                  Consultancy Services
                </li>
              </ul>
            </div>

            <Fade direction="up" duration={2000}>
              <h5 className="hoverclass">view my resume</h5>
            </Fade>
            <a
              className="btn"
              href="https://drive.google.com/file/d/102CijPxDlHqZiNlGZBG0qvgSy4XEPmYi/view?usp=drive_link"
              target="_blank"
              rel="noreferrer"
            >
              Resume <i className="ri-file-text-line"></i>
            </a>
            <br />
            <br />

            <div className="accordion-item">
              <h4 className="fw-bold">Stack & Tools</h4>
              <div className="tech-icons py-2">
                <i className="ci ci-reactjs ci-3x icontech"></i>
                <i className="ci ci-firebase ci-3x icontech"></i>
                <i className="ci ci-html5 ci-3x icontech"></i>
                <i className="ci ci-css ci-3x icontech"></i>
                <i className="ci ci-javascript ci-3x icontech"></i>
                <i className="ci ci-bootstrap ci-3x icontech"></i>
                <i className="ci ci-tailwind ci-3x icontech"></i>
                <i className="ci ci-javascript ci-3x icontech"></i>
                &nbsp; &nbsp; &nbsp;
                <i className="ci ci-vscode ci-3x icontech"></i>
                <i className="ci ci-github ci-3x icontech"></i>
                <i className="ci ci-python ci-3x icontech"></i>
                <i className="ci ci-cpp ci-3x icontech"></i>
                <i className="ci ci-c ci-3x icontech"></i>
                &nbsp; &nbsp; &nbsp;
                <i className="ci ci-figma ci-3x icontech"></i>
                <i className="ci ci-npm ci-3x icontech"></i>
                <i className="ci ci-netlify ci-3x icontech"></i>
                <i className="ci ci-vercel ci-3x icontech"></i>
                &nbsp; &nbsp; &nbsp;
                <i className="ci ci-servicenow ci-3x icontech"></i>
              </div>
            </div>
            {/* <h5 className="my-2 fw-bolder">Tech-Stack and Tools</h5>
            <div className="tech-icons">
              <i className="ci ci-reactjs ci-3x icontech"></i>
              <i className="ci ci-firebase ci-3x icontech"></i>
              <i className="ci ci-javascript ci-3x icontech"></i>
              <i className="ci ci-css ci-3x icontech"></i>
              <i className="ci ci-bootstrap ci-3x icontech"></i>
              <i className="ci ci-tailwind ci-3x icontech"></i>
              <i className="ci ci-html5 ci-3x icontech"></i>

              <i className="ci ci-vscode ci-3x icontech"></i>
              <i className="ci ci-github ci-3x icontech"></i>
              <i className="ci ci-python ci-3x icontech"></i>
              <i className="ci ci-cpp ci-3x icontech"></i>
              <i className="ci ci-c ci-3x icontech"></i>

              <i className="ci ci-figma ci-3x icontech"></i>

              <i className="ci ci-npm ci-3x icontech"></i>

              <i className="ci ci-netlify ci-3x icontech"></i>
              <i className="ci ci-vercel ci-3x icontech"></i>
            </div> */}
          </div>
        </div>

        <br />
        <br />
        <br />

        {/* Experience Section */}
        <div className="row">
          <div className="col-md-4 col-sm-4">
            <h1 className="head">Experience</h1>
            <h1 className="rc">
              <strong>
                <h5 className="highlightedtext">
                  Companies I've had worked with
                </h5>
              </strong>
            </h1>

            <br />

            <br />
          </div>

          <div className="col-md-8 col-sm-8">
            {" "}
            <div>
              <div className="education-timeline">
                <div className="education-item">
                  <div className="education-header">
                    <h4 className="fw-bold">
                      <i class="fa-solid fa-building"></i> Tata Consultancy
                      Services
                    </h4>
                    <span className="education-year">2024 - Current</span>
                  </div>
                  <p className="text-muted">
                    <strong>ServiceNow Developer</strong>
                    <br />
                    Specializing in SPM implementation and CAD-driven custom
                    application development. Expert in automating ITSM workflows
                    and architecting CSDM-compliant solutions to reduce manual
                    intervention and enhance enterprise visibility.
                  </p>

                  <div>
                    <p className="text">Certifications</p>
                    <div className="certifications-grid">
                      <div className="certification-card">
                        <div className="certification-icon">
                          <i className="fa-solid fa-certificate"></i>
                        </div>
                        <h6>ServiceNow Certified System Administrator</h6>
                        <p className="text-muted small">ServiceNow • 2025</p>
                        <span className="certification-badge">CSA</span>
                      </div>
                      <div className="certification-card">
                        <div className="certification-icon">
                          <i className="fa-solid fa-certificate"></i>
                        </div>
                        <h6>ServiceNow Certified Application Developer</h6>
                        <p className="text-muted small">ServiceNow • 2026</p>
                        <span className="certification-badge">CAD</span>
                      </div>
                      <div className="certification-card">
                        <div className="certification-icon">
                          <i className="fa-solid fa-certificate"></i>
                        </div>
                        <h6>
                          ServiceNow Specialist - Strategic Portfolio Management
                        </h6>
                        <p className="text-muted small">ServiceNow • 2026</p>
                        <span className="certification-badge">CIS-SPM</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="education-item">
                  <div className="education-header">
                    <h4 className="fw-bold">
                      <i class="fa-solid fa-graduation-cap"></i> Bachelor of
                      Technology in Computer Science
                    </h4>
                    <span className="education-year">2020 - 2024</span>
                  </div>
                  <p className="text-muted">
                    <strong>
                      Swami Keshvanand Institute of Technology, Jaipur
                    </strong>
                    <br />
                    Specialized in software development, algorithms, and system
                    design. Active member of technical clubs and participated in
                    various coding competitions.
                  </p>
                </div>
              </div>
            </div>{" "}
          </div>
        </div>
      </div>
    </div>
  );
}
